{
  "version": 1,
  "asset_id": "ae744315-7553-4a5b-9498-021b2b6691d7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ae744315-7553-4a5b-9498-021b2b6691d7/hiatal-type-4-v3-1254.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ae744315-7553-4a5b-9498-021b2b6691d7/hiatal-type-4-v3-1254.jpg",
  "original_filename": "hiatal-type-4-v3-1254.jpg",
  "size": 274372,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:03:47Z"
}
